module.exports = __webpack_public_path__ + "img/only-shadow.170868c5.svg";